import storeEvent from "../../utils/store-event";

export default class {
    onCreate() {
        this.state = {
            navOpen: false
        };
    }
    onMount() {
        const navBar = document.querySelector('nav.open');
        if (navBar) {
            this.state.navOpen = true;
        }

        storeEvent.toggleLeftNavDone.listen(data => {
            if (data.isOpen) {
                this.state.navOpen = true;
            } else {
                this.state.navOpen = false;
            }
        });
    }
}
